module.exports = __webpack_public_path__ + "assets/ab7d4dced54dbdb0f87f0db140aa9e78.png";